import { Button, Spinner } from "@shapr3d/frontend-lib";
import type React from "react";

import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";
import { ModelViewerWarningPage } from "../../pages/ModelViewerPage/ModelViewerWarningPage";
import { PublishVersionPromo } from "../PublishVersionPromo/PublishVersionPromo";

import style from "./ModelViewerOverlay.module.css";

interface ModelViewerOverlayProps {
  progress?: number;
  error?: boolean;
  onRetry?: () => void;
  showModelSizeWarning?: boolean;
  onDismissWarning?: () => void;
  warningBackground?: string;
  emptyState?: { canPublish: boolean };
  projectThumbnailUrl?: string;
}

const ModelViewerOverlay: React.FC<ModelViewerOverlayProps> = ({
  progress = 0,
  error,
  onRetry,
  showModelSizeWarning = false,
  onDismissWarning = () => {},
  warningBackground,
  emptyState,
  projectThumbnailUrl,
}) => {
  const tracker = useTracker();
  const { t, m } = useTranslation();

  if (emptyState) {
    return (
      <div className={style.modelViewerContainer}>
        <PublishVersionPromo
          canPublish={emptyState.canPublish}
          backgroundImage={projectThumbnailUrl}
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className={style.modelViewerContainer}>
        <div className={style.errorContainer}>
          <div className={style.errorTitle}>{t(m.ModelViewer.ErrorTitle)}</div>
          <div>{t(m.ModelViewer.ErrorMessage)}</div>
          <Button
            disabled={false}
            onClick={() => {
              tracker.trackButtonClick({ elementId: "webviewer-reload" });
              onRetry?.();
            }}
          >
            {t(m.ModelViewer.ReloadButton)}
          </Button>
        </div>
      </div>
    );
  }

  if (showModelSizeWarning) {
    return (
      <ModelViewerWarningPage
        onDismissWarning={onDismissWarning}
        backgroundImage={warningBackground}
      />
    );
  }
  return (
    <div className={style.modelViewerContainer}>
      <div>
        <Spinner />
        <div className={style.percentageIndicator}>{progress}%</div>
      </div>
    </div>
  );
};

export default ModelViewerOverlay;
